import { Inject, Pipe, PipeTransform } from '@angular/core';
import { IntegrationConnectionsDetail } from '../model/Integration-connections-detail';
import { ButtonConfigModel } from './marketing-page.component';
import { ConnectionMethods, ConnectionStatus, SupportedContexts } from '@vendasta/platform-integrations';
import { IntegrationType } from '../model/connection-integration-detail';
import { PLATFORM_INTEGRATIONS_CONTEXT_INJECTION_TOKEN$ } from '@galaxy/platform-integrations/shared';

@Pipe({
  name: 'buttonConfigPipe',
  standalone: true,
})
export class ButtonConfigPipe implements PipeTransform {
  constructor(
    @Inject(PLATFORM_INTEGRATIONS_CONTEXT_INJECTION_TOKEN$)
    public readonly context: SupportedContexts,
  ) {}

  transform(data: {
    cardDetail: IntegrationConnectionsDetail;
    namespace: string;
    integrationId: string;
    isSMB: boolean;
    isImpersonatedUser: boolean;
  }): ButtonConfigModel[] {
    const buttonConfigs = [];
    const addButtonConfig = (title, buttonType, color, action = '', isdisabled = false, toolTipMessage = '') => {
      buttonConfigs.push({
        title: title,
        buttonType: buttonType,
        color: color,
        action: action,
        isDisabled: isdisabled,
        toolTipMessage: toolTipMessage,
      });
    };

    const connectionMethod = data.cardDetail.integration.connectionMethod;
    const maxConnections = data.cardDetail.integration.maxConnections;
    const connectionStatus = data.cardDetail.connections[0]?.status;
    const integrationType = data.cardDetail.integration.integrationType.toLowerCase();

    //special case
    if (data.cardDetail.integration.integrationType.toLowerCase() === IntegrationType.ZAPIER.toLowerCase()) {
      addButtonConfig('INTEGRATION_CARD.CONNECT_ZAPIER', 'raised', 'primary');
      return buttonConfigs;
    }

    if (data.cardDetail.connections.length >= maxConnections && connectionStatus !== ConnectionStatus.PRECONNECTED) {
      addButtonConfig('INTEGRATION_CARD.MANAGE_CONNECTION', 'raised', 'primary');
    } else if (connectionMethod == ConnectionMethods.OAUTH2) {
      if (connectionStatus == ConnectionStatus.PRECONNECTED) {
        addButtonConfig('INTEGRATION_CARD.CANCEL', 'stroked', 'basic', 'CANCEL');
        addButtonConfig('INTEGRATION_CARD.RESUME_CONNECTION', 'raised', 'primary', 'RESUME');
      } else {
        addButtonConfig('INTEGRATION_CARD.ADD_CONNECTION', 'raised', 'primary');
      }
    } else if (connectionMethod == ConnectionMethods.VENDOR_MANAGED) {
      if (connectionStatus == ConnectionStatus.PRECONNECTED) {
        addButtonConfig('INTEGRATION_CARD.CANCEL_CONNECTION_REQUEST', 'stroked', 'warn');
      } else {
        addButtonConfig('INTEGRATION_CARD.REQUEST_CONNECTION', 'raised', 'primary');
      }
    } else if (connectionMethod == ConnectionMethods.APIKEY) {
      if (connectionStatus == ConnectionStatus.PRECONNECTED) {
        addButtonConfig('INTEGRATION_CARD.DISCONNECT', 'stroked', 'warn', 'CANCEL');
      } else {
        addButtonConfig('INTEGRATION_CARD.CONNECT', 'raised', 'primary');
      }
    } else if (connectionMethod == ConnectionMethods.LEGACY_OAUTH) {
      addButtonConfig('INTEGRATION_CARD.ADD_CONNECTION', 'raised', 'primary');
    }

    const isQuickBooksRestricted =
      integrationType === IntegrationType.QUICKBOOKSONLINEPERSONAL.toLowerCase() &&
      !data.isSMB &&
      this.context === SupportedContexts.PI_CONTEXT_SMB;

    const isMeetRestricted =
      [
        IntegrationType.GOOGLEMEET.toLowerCase(),
        IntegrationType.ZOOMMEET.toLowerCase(),
        IntegrationType.MICROSOFTTEAMS,
      ].includes(integrationType) && data.isImpersonatedUser;

    for (const button of buttonConfigs) {
      if (isQuickBooksRestricted) {
        button.isDisabled = true;
        button.toolTipMessage = 'INTEGRATION_CARD.SMB_USERS_ONLY_CONNECTION_TOOLTIP';
      } else if (isMeetRestricted) {
        button.isDisabled = true;
        button.toolTipMessage = 'INTEGRATION_CARD.IMPERSONATE_USERS_CANNOT_CONNECT_TOOLTIP';
      }
    }

    return buttonConfigs;
  }
}
